import { isEmpty } from 'lodash';
import { CustomValidateResolveType } from 'tdesign-react';

const validateStories: (
  data: any,
  isBanner: boolean
) => CustomValidateResolveType = (data, isBanner) => {
  if (isEmpty(data?.story)) {
    return { result: false, message: '请选择故事', type: 'error' };
  }
  if (isBanner && data?.story?.length < 5) {
    return { result: false, message: '最少选择5个故事', type: 'error' };
  }
  return true;
};

export { validateStories };
